module.exports = __webpack_public_path__ + "img/17a002-18.b86b1c45.png";